import _regenerator from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { getSalaryStatistics, exportSalary } from '@/services/salary';
import { getDictFixInfo } from '@/services/basicDataMgr';
import moment from 'moment';
import { message } from 'ant-design-vue';
export default {
  name: 'SalaryStatistics',
  data: function data() {
    return {
      queryForm: {
        dateRange: [],
        type: 1,
        depts: [],
        fields: []
      },
      showReport: false,
      loading: false,
      reportData: [],
      deptOptions: [],
      columns: []
    };
  },
  computed: {
    fieldOptions: function fieldOptions() {
      if (this.queryForm.type === 1) {
        return [{
          label: '档案工资',
          value: 'baseSalary'
        }, {
          label: '基础性绩效',
          value: 'basePerformance'
        }, {
          label: '奖励性绩效',
          value: 'rewardPerformance'
        }, {
          label: '加班工资',
          value: 'overtimePay'
        }, {
          label: '其他',
          value: 'otherPay'
        }, {
          label: '年终奖',
          value: 'yearEndBonus'
        }, {
          label: '春季学期目标奖',
          value: 'springBonus'
        }, {
          label: '秋季学期目标奖',
          value: 'autumnBonus'
        }, {
          label: '校长基金',
          value: 'principalFund'
        }, {
          label: '应发合计',
          value: 'totalAmount'
        }];
      } else {
        return [{
          label: '固定薪酬',
          value: 'fixedPay'
        }, {
          label: '考核薪酬',
          value: 'assessmentPay'
        }, {
          label: '绩效薪酬',
          value: 'performancePay'
        }, {
          label: '应发合计',
          value: 'totalAmount'
        }];
      }
    }
  },
  watch: {
    'queryForm.type': function queryFormType() {
      this.queryForm.depts = [];
      this.queryForm.fields = [];
      this.fetchDeptOptions();
    }
  },
  created: function created() {
    this.initColumns();
    this.fetchDeptOptions();
  },
  methods: {
    fetchDeptOptions: function fetchDeptOptions() {
      var _this = this;
      var categoryId = this.queryForm.type === 1 ? 31 : 30;
      getDictFixInfo({
        categoryId: categoryId,
        pageCurrent: 1,
        pageSize: 100,
        status: 3
      }).then(function (res) {
        var result = res.data.data || res.data;
        if (result && result.records) {
          _this.deptOptions = result.records.map(function (item) {
            return item.name;
          });
        }
      });
    },
    initColumns: function initColumns() {
      var _this2 = this;
      var h = this.$createElement;
      // 定义基础固定列
      var baseColumns = [{
        title: '序号',
        key: 'serial',
        width: 70,
        //   fixed: 'left', 
        customRender: function customRender(text, record) {
          var obj = {
            children: record.serialNo,
            attrs: {}
          };
          if (record.rowType === 'summary' || record.rowType === 'total') {
            obj.children = h("b", {
              "style": "white-space: nowrap;"
            }, ["".concat(record.name || '')]);
            obj.attrs.colSpan = 4;
          }
          return obj;
        }
      }, {
        title: '姓名',
        dataIndex: 'name',
        width: 90,
        //   fixed: 'left',
        customRender: function customRender(text, record) {
          var obj = {
            children: text,
            attrs: {}
          };
          if (record.rowType === 'summary' || record.rowType === 'total') {
            obj.attrs.colSpan = 0;
          }
          return obj;
        }
      }, {
        title: '身份证号码',
        dataIndex: 'idCard',
        width: 160,
        customRender: function customRender(text, record) {
          var obj = {
            children: text,
            attrs: {}
          };
          if (record.rowType === 'summary' || record.rowType === 'total') {
            obj.attrs.colSpan = 0;
          }
          return obj;
        }
      }, {
        title: '学部',
        dataIndex: 'department',
        width: 120,
        customRender: function customRender(text, record) {
          var obj = {
            children: text,
            attrs: {}
          };
          if (record.rowType === 'summary' || record.rowType === 'total') {
            obj.attrs.colSpan = 0;
          }
          return obj;
        }
      }];
      var dynamicColumns = [];
      if (this.queryForm.type === 1) {
        // 教职工模板
        var groups = [{
          title: '固定薪酬',
          children: [{
            title: '档案工资',
            dataIndex: 'baseSalary',
            width: 80
          }, {
            title: '基础性绩效',
            dataIndex: 'basePerformance',
            width: 80
          }]
        }, {
          title: '考核薪酬',
          children: [{
            title: '奖励性绩效',
            dataIndex: 'rewardPerformance',
            width: 80
          }, {
            title: '加班工资',
            dataIndex: 'overtimePay',
            width: 80
          }, {
            title: '其他',
            dataIndex: 'otherPay',
            width: 80
          }]
        }, {
          title: '绩效薪酬',
          children: [{
            title: '年终奖',
            dataIndex: 'yearEndBonus',
            width: 80
          }, {
            title: '春季学期目标奖',
            dataIndex: 'springBonus',
            width: 90
          }, {
            title: '秋季学期目标奖',
            dataIndex: 'autumnBonus',
            width: 90
          }]
        }, {
          title: '校长基金',
          dataIndex: 'principalFund',
          width: 80
        }];
        if (this.queryForm.fields && this.queryForm.fields.length > 0) {
          dynamicColumns = groups.map(function (group) {
            if (group.children) {
              var filteredChildren = group.children.filter(function (child) {
                return _this2.queryForm.fields.includes(child.dataIndex);
              });
              return filteredChildren.length > 0 ? _objectSpread(_objectSpread({}, group), {}, {
                children: filteredChildren
              }) : null;
            }
            return _this2.queryForm.fields.includes(group.dataIndex) ? group : null;
          }).filter(Boolean);
        } else {
          dynamicColumns = groups;
        }
      } else {
        // 工勤人员模板
        var fields = [{
          title: '固定薪酬',
          dataIndex: 'fixedPay',
          width: 100
        }, {
          title: '考核薪酬',
          dataIndex: 'assessmentPay',
          width: 100
        }, {
          title: '绩效薪酬',
          dataIndex: 'performancePay',
          width: 100
        }];
        if (this.queryForm.fields && this.queryForm.fields.length > 0) {
          dynamicColumns = fields.filter(function (f) {
            return _this2.queryForm.fields.includes(f.dataIndex);
          });
        } else {
          dynamicColumns = fields;
        }
      }
      var totalColumn = {
        title: '应发合计',
        dataIndex: 'totalAmount',
        width: 100
      };
      this.columns = [].concat(baseColumns, _toConsumableArray(dynamicColumns), [totalColumn]);
    },
    handlePanelChange: function handlePanelChange(value, mode) {
      this.queryForm.dateRange = value;
    },
    resetQuery: function resetQuery() {
      this.queryForm = {
        dateRange: [],
        type: 1,
        depts: [],
        fields: []
      };
      this.showReport = false;
    },
    generateReport: function generateReport() {
      var _this3 = this;
      // 校验日期范围必填
      if (!this.queryForm.dateRange || this.queryForm.dateRange.length !== 2 || !this.queryForm.dateRange[0] || !this.queryForm.dateRange[1]) {
        this.$message.warning('请选择统计时间范围');
        return;
      }
      this.initColumns(); // 动态更新列定义
      this.loading = true;
      this.showReport = true;
      var params = _objectSpread(_objectSpread({}, this.queryForm), {}, {
        startMonth: this.queryForm.dateRange[0].format('YYYY-MM'),
        endMonth: this.queryForm.dateRange[1].format('YYYY-MM')
      });
      getSalaryStatistics(params).then(function (res) {
        // 兼容处理：支持 { data: { list, ... } } 和 { list, ... } 两种结构
        var result = res.data.data || res.data;
        var rawList = result.list || (Array.isArray(result) ? result : []);

        // 为明细行添加序号
        var detailIndex = 0;
        _this3.reportData = rawList.map(function (item) {
          if (item.rowType === 'detail') {
            detailIndex++;
            return _objectSpread(_objectSpread({}, item), {}, {
              serialNo: detailIndex
            });
          }
          return item;
        });
        _this3.loading = false;
      }).catch(function () {
        _this3.loading = false;
      });
    },
    exportReport: function exportReport() {
      // 如果没有选择字段，默认导出当前类型的所有字段
      var fields = this.queryForm.fields;
      if (!fields || fields.length === 0) {
        fields = this.fieldOptions.map(function (opt) {
          return opt.value;
        });
      }
      var params = _objectSpread(_objectSpread({}, this.queryForm), {}, {
        fields: ['salaryMonth'].concat(_toConsumableArray(fields)),
        // 强制在导出字段中加入月份
        startMonth: this.queryForm.dateRange[0] ? this.queryForm.dateRange[0].format('YYYY-MM') : null,
        endMonth: this.queryForm.dateRange[1] ? this.queryForm.dateRange[1].format('YYYY-MM') : null
      });
      message.loading({
        content: '报表导出中...',
        key: 'exportSalary'
      });
      exportSalary(params).then(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(response) {
          var contentType, result, buffer, blob, url, link;
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                // 1. 首先检查 Content-Type，如果是 JSON 说明是错误消息
                contentType = response.headers.get('content-type');
                if (!(contentType && contentType.includes('application/json'))) {
                  _context.n = 2;
                  break;
                }
                _context.n = 1;
                return response.json();
              case 1:
                result = _context.v;
                message.error({
                  content: result.message || result.error || '导出失败',
                  key: 'exportSalary'
                });
                return _context.a(2);
              case 2:
                if (response.ok) {
                  _context.n = 3;
                  break;
                }
                message.error({
                  content: "\u5BFC\u51FA\u5931\u8D25 (\u72B6\u6001\u7801: ".concat(response.status, ")"),
                  key: 'exportSalary'
                });
                return _context.a(2);
              case 3:
                _context.n = 4;
                return response.arrayBuffer();
              case 4:
                buffer = _context.v;
                message.success({
                  content: '导出成功',
                  key: 'exportSalary'
                });
                blob = new Blob([buffer], {
                  type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                });
                url = window.URL.createObjectURL(blob);
                link = document.createElement('a');
                link.style.display = 'none';
                link.href = url;
                link.setAttribute('download', "\u5DE5\u8D44\u7EDF\u8BA1\u62A5\u8868_".concat(moment().format('YYYYMMDD'), ".xlsx"));
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
              case 5:
                return _context.a(2);
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }()).catch(function (err) {
        message.error({
          content: '报表导出失败',
          key: 'exportSalary'
        });
      });
    },
    getRowClassName: function getRowClassName(record) {
      if (record.rowType === 'summary') return 'summary-row';
      if (record.rowType === 'total') return 'total-row';
      return '';
    }
  }
};